import {gql} from "@apollo/client";
import {AccountType} from "graphql/types/AccountType";

export const GET_ACCOUNT_LISTING_FOR_TMS = gql`
    query GetAccountListingForTms($warehouseId: Long!) {
        allAccounts: getAccountListingForTms(warehouseId: $warehouseId) {
            id
            name
            countryCode
            phone
            email
            status
            role {
                name
            }
            createdAt
            updatedAt
        }
    }
`;

export interface getAccountListingForTmsResponse {
    allAccounts: AccountType[];
}

export const GET_ACCOUNT_LISTING_FOR_TMS_WITH_PAGINATION = gql`
    query GetAccountListingForTmsWithPagination(
        $filter: TmsAccountFiltersInput,
        $pageRequest: PageRequestTypeInput
    ) {
        getAccountListingForTmsWithPagination(
            filters: $filter,
            pageRequest: $pageRequest
        ) {
            content {
                id
                name
                countryCode
                phone
                email
                status
                role {
                    name
                }
                carrierId
                createdAt
                updatedAt
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface TmsAccountItemType {
    id: string;
    name: string;
    countryCode: number | null;
    phone: string | null;
    email: string | null;
    status: number;
    role: {
        name: string;
    };
    carrierId: number | null;
    createdAt: string | null;
    updatedAt: string | null;
}

export interface TmsAccountListingResponseType {
    content: TmsAccountItemType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

export interface getAccountListingForTmsWithPaginationResponse {
    getAccountListingForTmsWithPagination: TmsAccountListingResponseType;
}

